import 'ng-file-upload';

import {Component, Module} from 'app/decorators';

import {FileUpload} from 'app/common/files.upload';
import Modal from 'app/services/modals';
import TokenService from 'app/services/token';

import FileStore from 'app/stores/file';
import MimeTypeIconComponent from 'app/directives/mimetype.icon';

import tpl from './upload.section.html';


@Module({
    name: "app.directives.upload",
    modules: [
        TokenService,
        FileStore,
        Modal,
        'ngFileUpload',
        MimeTypeIconComponent,
    ],
})
@Component({
    selector: 'blnd-upload-section',
    bindings: {
        ngModel: '=',
        type: '@',
    },
    template: tpl,
})
export default class C{
    constructor ($growl, $cookies, TokenService, Modal, Upload, FileStore) {
        "ngInject";
        this.$growl = $growl;
        this.Modal = Modal;
        this.store = FileStore;
        this.store.init();
        this.store.params.type = this.type;
        this.store.params.object_id = this.ngModel.id;
        this.store.refresh();
        this.fileUpload = new FileUpload($cookies, TokenService, FileStore, Upload);
    }

    deleteFile (name, id) {
        let self = this;
        let $modal = self.Modal.openConfirmDelete({
            text: `Are you sure to delete file ${name} ?`,
        });
        $modal.wait.then(function(result){
            self.store.remove(id).then(function(){
                result.close();
                self.$growl.deleted();
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/upload.section.js